import { lazy } from 'react';
import type { RouteProps } from 'react-router-dom';

const SubmitInquiry = lazy(() => import('./index'));

/** 路由配置 */
export const routeConfig: RouteProps[] = [
  {
    path: '/submitInquiry',
    element: <SubmitInquiry />,
  },
];
